export const environment = {
  stage: 'prod',
  production: true,
  identityPoolId: 'eu-central-1:e8191332-3e1d-4bfc-9e1f-4085b83b16b9',
  region: 'eu-central-1',
  assetsBucketName: '',
  userPoolId: 'eu-central-1_jfU56jj7j',
  websocketUrl: 'wss://vgvp32pmp4.execute-api.eu-central-1.amazonaws.com/prod',
  websocketReconnectDelay: 2000,
  clientId: '2ea1lv0tds4s0a68ka4iqkac0j',
  cognitoDomainPrefix: 'draexlmaier-picturetocloud',
  cognitoRedirectUri: 'https://data2cloud.draexlmaier.solutions/secure',
  cognitoLogoutUri: 'https://data2cloud.draexlmaier.solutions//public',
  filesUrl: 'assets',
  restApiUrl: 'https://rssc87qec6.execute-api.eu-central-1.amazonaws.com/prod',
};
